(() => {
  'use strict';

  const brandLogos = {
    wago: { src: window.USAC_WAGO_LOGO_URL, label: 'WAGO' },
    leuze: { src: window.USAC_LEUZE_LOGO_URL, label: 'Leuze' },
    panasonic: { src: window.USAC_PANASONIC_LOGO_URL, label: 'Panasonic Industry' },
  };
  if (!Object.values(brandLogos).some((brand) => brand.src)) return;

  const normalize = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();

  function decorate(link) {
    const brandKey = normalize(link.textContent || '');
    const brand = brandLogos[brandKey];
    if (!brand?.src || link.dataset.usacBrand === brandKey) return;

    link.dataset.usacBrand = brandKey;
    link.classList.add('usac-manufacturer-brand-link');
    link.setAttribute('aria-label', brand.label);
    link.textContent = '';

    const logo = document.createElement('img');
    logo.src = brand.src;
    logo.alt = brand.label;
    logo.className = 'usac-manufacturer-brand-link__logo';
    link.appendChild(logo);
  }

  function applyBranding() {
    document.querySelectorAll('header a, header-menu a, [role="banner"] a, .header a, .menu a, .drawer a').forEach(decorate);
  }

  const style = document.createElement('style');
  style.textContent = '.usac-manufacturer-brand-link{display:inline-flex !important;align-items:center;min-height:20px;}.usac-manufacturer-brand-link__logo{display:block;width:48px;max-width:100%;height:auto;}';
  document.head.appendChild(style);

  applyBranding();
  new MutationObserver(applyBranding).observe(document.documentElement, { childList: true, subtree: true });
  let attemptsRemaining = 40;
  const hydrationRetry = window.setInterval(() => {
    applyBranding();
    attemptsRemaining -= 1;
    if (attemptsRemaining <= 0) window.clearInterval(hydrationRetry);
  }, 250);
})();